import { motion } from "framer-motion";
import { useEffect, useState } from "react";

function Gallery({ baseURL }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(baseURL + "gallery")
      .then((res) => res.json())
      .then((data) => setItems(data));
  }, [baseURL]);

  if (items.length === 0) {
    return <p>No hay imágenes disponibles.</p>;
  }

  const firstThree = items.slice(0, 3);
  const rest = items.slice(3);

  return (
    <div>
      <motion.div className="gallery">
        {firstThree.map((item, index) => (
          <img key={index} src={item.image} alt={`Imagen ${index + 1}`} />
        ))}
      </motion.div>

      {rest.length > 0 && (
        <details>
          <summary>Ver más...</summary>
          <div className="gallery">
            {rest.map((item, index) => (
              <img
                key={index + 3}
                src={item.image}
                alt={`Imagen ${index + 4}`}
              />
            ))}
          </div>
        </details>
      )}
    </div>
  );
}

export default Gallery;
